import type { DeliverySchedule, UpcomingOrder } from '@/services/order'

export type FutureOrder = {
  scheduledAt: string
  addressId: number
  orders: UpcomingOrder[]
}

export const buildFutureOrdersFromDeliveryScheduleResponse = (
  futureOrdersFromDeliverySchedule: DeliverySchedule,
): FutureOrder[] => {
  // Create a map to group orders by date and address_id
  const orderMap = new Map<string, FutureOrder>()

  futureOrdersFromDeliverySchedule.deliveries.forEach((delivery) => {
    delivery.orders.forEach((order) => {
      // Create a unique key combining date and address_id
      const key = `${delivery.date}-${order.address_id}`

      if (orderMap.has(key)) {
        // If an order exists for this date and address_id, add to its orders array
        const existingOrder = orderMap.get(key)!
        existingOrder.orders.push(order)
      } else {
        // Create a new order entry
        orderMap.set(key, {
          scheduledAt: delivery.date,
          addressId: order.address_id,
          orders: [order],
        })
      }
    })
  })

  // Convert the map values to an array
  return Array.from(orderMap.values())
}
